import { resolveGameContentType } from "./contentType";
import { hasAnyScenarioVideo } from "./telegramPreview";
import { getProjectStatusFromSettings } from "./projectAccess";

const LINK_COPIED_KEY_PREFIX = "mogame:link-copied:";

export function markShareLinkCopied(gameId) {
  if (!gameId) return;
  localStorage.setItem(`${LINK_COPIED_KEY_PREFIX}${gameId}`, String(Date.now()));
}

export function wasShareLinkCopied(gameId) {
  if (!gameId) return false;
  return Boolean(localStorage.getItem(`${LINK_COPIED_KEY_PREFIX}${gameId}`));
}

function hasScenarioContent(game) {
  return hasAnyScenarioVideo(game);
}

function hasTrainerContent(game) {
  const hasQuestions = (game?.trainerQuestions ?? []).some((item) =>
    item?.questionText?.trim(),
  );
  return hasQuestions || Boolean(game?.trainerTheme?.trim());
}

function hasKnowledgeBaseContent(game) {
  return (game?.kbItems ?? []).some(
    (item) =>
      item?.question?.trim() ||
      item?.answerText?.trim() ||
      item?.hasVideo,
  );
}

function hasCourseContent(game) {
  return (game?.courseLessons ?? []).some((lesson) =>
    lesson?.title?.trim(),
  );
}

export function hasLaunchContent(game) {
  if (!game) return false;

  const type = resolveGameContentType(game);
  if (type === "trainer") return hasTrainerContent(game);
  if (type === "knowledge_base") return hasKnowledgeBaseContent(game);
  if (type === "course") return hasCourseContent(game);
  return hasScenarioContent(game);
}

export function hasLaunchStartPost(game, draftSettings = null) {
  const title = (draftSettings?.title ?? game?.title ?? "").trim();
  const description = (draftSettings?.description ?? game?.description ?? "").trim();
  return Boolean(title && description);
}

export function isLaunchPublished(game, draftSettings = null) {
  const status = draftSettings?.projectStatus
    ?? getProjectStatusFromSettings(game?.settings);
  return status === "published";
}

export function getLaunchContentLabel(game) {
  const type = resolveGameContentType(game);
  if (type === "trainer") return "Есть вопросы в тренажёре";
  if (type === "knowledge_base") return "Есть материалы в базе знаний";
  if (type === "course") return "Есть уроки в курсе";
  return "Есть видео в сценарии";
}

export function getLaunchReadiness(game, draftSettings = null) {
  const published = isLaunchPublished(game, draftSettings);
  const items = [
    {
      id: "content",
      label: getLaunchContentLabel(game),
      done: hasLaunchContent(game),
      hint: "Добавьте контент в редакторе проекта.",
    },
    {
      id: "startPost",
      label: "Стартовый пост заполнен",
      done: hasLaunchStartPost(game, draftSettings),
      hint: "Укажите название и текст приветствия в блоке «Стартовый пост».",
    },
    {
      id: "published",
      label: "Проект опубликован",
      done: published,
      hint: "Выберите статус «Опубликован» и сохраните настройки.",
    },
    {
      id: "linkCopied",
      label: "Ссылка скопирована",
      done: published && wasShareLinkCopied(game?._id),
      optionalUntilPublished: true,
      hint: published
        ? "Скопируйте ссылку в блоке «Доступ для команды»."
        : "Станет доступно после публикации.",
    },
  ];

  const doneCount = items.filter((item) => item.done).length;

  return {
    items,
    doneCount,
    total: items.length,
    allDone: doneCount === items.length,
  };
}
